import { ValueChartDataProvider, ValueChartItem } from "@Modules/analytics/Components/PercentValueChart/ValueChart";
import { TopReferrerResponseItem } from "@Modules/analytics/Api/TopReferrerStatsApi.ts";

/**
 * Represents the popularity stats data that we receive from the server. This data will be 
 * shown on a graph on the analytics page
*/
export default abstract class ValueChartData<T extends TopReferrerResponseItem = TopReferrerResponseItem> implements ValueChartDataProvider {
    public readonly dataset: ValueChartItem[];
    public readonly other: number;
    public readonly total: number;
    public readonly from: string | null;
    public readonly to: string | null;

    constructor(
        dataset: T[] = [],
        other: number = 0,
        total: number = 0,
        from: string | null = null,
        to: string | null = null,
    ) {
        this.other = other;
        this.total = total;

        /**
        * The data shape used by the chart is different than the data that is sent to 
        * us from the server so we need to convert it.
        */
        this.dataset = dataset
            .sort((a: T, b: T) => a.hits - b.hits)
            .map((item): ValueChartItem => ({
                name: item.source,
                value: item.hits,
                children: [],
            }));

        this.from = from;
        this.to = to;
    }

    public getRawData(): ValueChartItem[] {
        return this.dataset;
    }

    public getChartTotal(): number {
        return this.total;
    }

    public getChartLabels(): string[] {
        return Object.values(this.getChartData()).map((item) => item.name);
    }

    public abstract getChartData(): ValueChartItem[];
}
